export default __webpack_public_path__ + "static/media/1.15b961a3.png";